<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container contents">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <div id="cart-page">
            <!-- End Transparent Message -->
            <div class="row ">
              <div class="col-lg-8">
                <!-- Mobile-only order items: shown first on mobile; hidden on desktop
                     (the sidebar copy in the right column is used there). Keep in sync. -->
                <div class="order-items-card mb-4 d-lg-none">
                  <div class="order-items-card__header">
                    আপনার অর্ডার ({{ cart.length }} আইটেম)
                  </div>
                  <section class="cart-items">
                    <div v-for="(item, k) in cart" :key="'m' + k" class="cart-item">
                      <div class="cart-row">
                        <a :href="`/book/${item.product_id}`" class="cart-row__thumb">
                          <img
                            class="cart-image"
                            :src="`${IMAGEURL}${item.image}`"
                            alt=""
                          />
                        </a>
                        <div class="cart-row__body">
                          <div class="cart-row__head">
                            <a :href="`/book/${item.product_id}`" class="cart-row__name">
                              {{ item.name }}
                            </a>
                            <a
                              @click="removeFromCart(item)"
                              href="javascript:;"
                              class="cart-row__remove"
                              title="Remove"
                            >
                              <i class="fa fa-times"></i>
                            </a>
                          </div>
                          <div class="cart-row__calc">
                            <div class="qty-stepper">
                              <button class="btn js-minus-btn" @click="decQty(item)">
                                <i class="fa fa-minus"></i>
                              </button>
                              <input
                                type="text"
                                class="form-control js-quantity-input product-qty bg-white"
                                :value="`${item.quantity}`"
                                disabled
                              />
                              <button class="btn js-plus-btn" @click="incQty(item)">
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>
                            <div class="cart-row__math">
                              <span class="unit">× ৳{{ item.price }}</span>
                              <span class="eq">=</span>
                              <strong class="line-total">৳{{ (item.quantity * item.price).toFixed(2) }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Cart Item -->
                  </section>
                </div>

                <section class="shipping-address mb-4 p-3">
                  <div class="checkout-sidebar__header border-heading">
                      <h1>শপিং ঠিকানা</h1>
                    </div>
                  <form>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="mobile">মোবাইল নাম্বার<span class="text-danger">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          id="mobile"
                          v-model="customerInfo.mobile"
                          :class="{'is-invalid': mobileError, 'is-valid': isValidMobile}"
                          placeholder=" আপনার মোবাইল নাম্বার লিখুন"
                          @input="validateMobile"
                        >
                        <div class="invalid-feedback" v-if="mobileError">
                          সঠিক মোবাইল নাম্বার দিন (১১ ডিজিট)
                        </div>
                        <small class="form-text text-success" v-if="isValidMobile">
                          <i class="fa fa-check-circle"></i>
                        </small>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="name">নাম<span class="text-danger">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="customerInfo.name"
                          placeholder=" আপনার নাম লিখুন"
                        >
                        <small class="form-text text-success" v-if="customerInfo.name">
                          <i class="fa fa-check-circle"></i>
                        </small>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="address">ঠিকানা<span class="text-danger">*</span></label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="address"
                        v-model="customerInfo.address"
                        placeholder="আপনার ঠিকানা লিখুন"
                      >
                      <small class="form-text text-success" v-if="customerInfo.address">
                        <i class="fa fa-check-circle"></i>
                      </small>
                    </div>
                  </form>
                </section>

                <section class="delivery-section mb-4 p-3">
                  <h4>এরিয়া সিলেক্ট করুন</h4>
                  <div class="delivery-options">
                    <div v-for="(type, index) in shippingTypes"
                         :key="index"
                         class="delivery-option"
                         :class="{ 'active': order.shipping_rate_id === type.id }"
                         @click="selectShippingType(type)">
                      <div class="d-flex align-items-center">
                        <div class="radio-dot">
                          <i class="fa fa-check" v-if="order.shipping_rate_id == type.id"></i>
                        </div>
                        <div class="flex-grow-1">
                          <h5>{{ type.title }}</h5>
                          <small v-if="freeShippingApplies(type)">ডেলিভারি চার্জ <s>{{ type.inside_price }}</s> ফ্রি ডেলিভারি 🎉</small>
                          <small v-else>ডেলিভারি চার্জ {{ type.inside_price }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="payment-section mb-4 p-3">
                  <h4>পে করুন</h4>
                  <div class="payment-options">
                    <div class="payment-option"
                         :class="{ 'active': order.payment_type === 'COD' }"
                         @click="selectPaymentType('COD')">
                      <div class="d-flex align-items-center">
                        <div class="radio-dot">
                          <i class="fa fa-check" v-if="order.payment_type === 'COD'"></i>
                        </div>
                        <div class="flex-grow-1">
                          <h5>Cash On Delivery</h5>
                          <small>Tk. {{ grandTotal }}</small>
                        </div>
                        <div class="payment-icon">
                          <img src="/assets/img/cod.png" alt="cod" height="40">
                        </div>
                      </div>
                    </div>

                    <div class="payment-option"
                         :class="{ 'active': order.payment_type === 'SSL' }"
                         @click="selectPaymentType('SSL')">
                      <div class="d-flex align-items-center">
                        <div class="radio-dot">
                          <i class="fa fa-check" v-if="order.payment_type === 'SSL'"></i>
                        </div>
                        <div class="flex-grow-1">
                          <h5>Online Payment</h5>
                          <small>Tk. {{ grandTotal }}</small>
                        </div>
                        <div class="payment-icon">
                          <img src="/assets/img/ssl.png" alt="ssl" height="35">
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div class="col-lg-4">
                <!-- Desktop items card (sidebar). Mobile shows the copy at the top
                     of the left column instead — keep both markups in sync. -->
                <div class="order-items-card mb-4 d-none d-lg-block">
                  <div class="order-items-card__header">
                    আপনার অর্ডার ({{ cart.length }} আইটেম)
                  </div>
                  <section id="cart-content" class="cart-items">
                    <div v-for="(item, k) in cart" :key="k" class="cart-item">
                      <div class="cart-row">
                        <a :href="`/book/${item.product_id}`" class="cart-row__thumb">
                          <img
                            class="cart-image"
                            :src="`${IMAGEURL}${item.image}`"
                            alt=""
                          />
                        </a>
                        <div class="cart-row__body">
                          <div class="cart-row__head">
                            <a :href="`/book/${item.product_id}`" class="cart-row__name">
                              {{ item.name }}
                            </a>
                            <a
                              @click="removeFromCart(item)"
                              href="javascript:;"
                              class="cart-row__remove"
                              title="Remove"
                            >
                              <i class="fa fa-times"></i>
                            </a>
                          </div>
                          <div class="cart-row__calc">
                            <div class="qty-stepper">
                              <button class="btn js-minus-btn" @click="decQty(item)">
                                <i class="fa fa-minus"></i>
                              </button>
                              <input
                                type="text"
                                class="form-control js-quantity-input product-qty bg-white"
                                :value="`${item.quantity}`"
                                disabled
                              />
                              <button class="btn js-plus-btn" @click="incQty(item)">
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>
                            <div class="cart-row__math">
                              <span class="unit">× ৳{{ item.price }}</span>
                              <span class="eq">=</span>
                              <strong class="line-total">৳{{ (item.quantity * item.price).toFixed(2) }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Cart Item -->
                  </section>
                </div>

                <div class="fixed-checkout">
                  <section id="checkout-sidebar" class="check-sidebar p-3">
                    <div class="checkout-sidebar__header">
                      <h1>চেকআউট সামারি</h1>
                    </div>

                    <div class="d-flex justify-content-between summary-row">
                      <div>সাব টোটাল</div>
                      <div>Tk. {{ amount }}</div>
                    </div>

                    <div class="d-flex justify-content-between summary-row">
                      <div>ডেলিভারি চার্জ</div>
                      <div>Tk. {{ deliveryCharge }}</div>
                    </div>

                    <div class="d-flex justify-content-between summary-row">
                      <div>ডিসকাউন্ট</div>
                      <div>Tk. {{ discount }}</div>
                    </div>

                    <div class="d-flex justify-content-between summary-row" v-if="giftPrice > 0">
                      <div>মোড়ানো</div>
                      <div>Tk. {{ giftPrice }}</div>
                    </div>

                    <!-- <div class="d-flex justify-content-between summary-row">
                      <div>টোটাল</div>
                      <div>Tk. {{ amount }}</div>
                    </div> -->

                    <div
                      class="d-flex justify-content-between summary-row border-bottom-0 mb-4"
                    >
                      <div>গ্রান্ড টোটাল</div>
                      <div>Tk. {{ grandTotal }}</div>
                    </div>

                    <div class="checkout-sidebar__content">
                      <div class="payment-breakdown">
                        <div class="payment-breakdown__content"></div>
                      </div>
                      <div class="gift-wrap">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="js-gift-checkbox"
                            @click="giftToggle"
                          />
                          <label
                            class="custom-control-label"
                            for="js-gift-checkbox"
                          >
                            Gift Wrap for Tk. 20
                          </label>
                        </div>
                      </div>
                    </div>
                    <!--End checkout-sidebar__content -->
                  </section>
                  <div class="coupon-section">
                    <div class="card">
                      <div class="js--coupon-header">
                        <!-- Accordion -->
                        <div id="accordionExample" class="accordion shadow">
                          <!-- Accordion item 1 -->
                          <div class="card">
                            <div
                              id="headingOne"
                              class="card-header bg-white shadow-sm border-0"
                            >
                              <h2 class="mb-0">
                                <button
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#collapseOne"
                                  aria-expanded="false"
                                  aria-controls="collapseOne"
                                  class="btn btn-link text-dark font-weight-bold text-uppercase collapsible-link"
                                >
                                  Add Promo code or Gift voucher
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapseOne"
                              aria-labelledby="headingOne"
                              data-parent="#accordionExample"
                              class="collapse"
                            >
                              <div class="card-body p-3">
                                <div class="input-group">
                                  <input
                                    v-model="promoCode"
                                    type="text"
                                    class="form-control"
                                    :disabled="couponDisabled == 1"
                                    :placeholder="`${placeHolder}`"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2"
                                  />
                                  <div class="input-group-append">
                                    <button
                                      @click="validatePromo"
                                      class="btn btn-outline-secondary"
                                      type="button"
                                      :disabled="couponDisabled == 1"
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- End -->
                        </div>
                        <!-- End -->
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 mb-1 pb-3 cart-actions">
                    <button
                      :disabled="!isValidForCheckout || submitted"
                      @click="placeOrder"
                      href="javascript:;"
                      class="btn btn-primary btn-block"
                      id="js-continue-to-gift-shipping"
                      >অর্ডার সম্পন্ন করুন <i class="fa fa-chevron-circle-right"></i>
                    </button>
                  </div>
                </div>

                <div v-if="deliveryContents" class="bg-light p-2 font-14 mt-3">
                  <div class="d-flex" v-if="deliveryContents.title">
                    <div class="p-1">
                      <i class="fa fa-cash-register"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.title }}
                    </div>
                  </div>
                  <div class="d-flex" v-if="deliveryContents.short_description">
                    <div class="p-1">
                      <i class="fa fa-undo-alt"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.short_description }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="p-1">
                      <i class="fa fa-truck"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.custom_field }}
                      <div>
                        {{ deliveryContents.custom_field2 }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="p-1">
                      <i class="fa fa-trophy"></i>
                    </div>
                    <div class="p-1">
                      {{ deliveryContents.custom_field3 }}
                      <div>
                        {{ deliveryContents.custom_field4 }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Cart`,
  components: {
    Layout
  },
  computed: {
    isValidCustomerInfo() {
      return this.isValidMobile &&
             this.customerInfo.name.trim() !== '' &&
             (this.customerInfo.address || '').trim() !== '';
    },
    isValidForCheckout() {
      return this.isValidCustomerInfo && this.cart.length > 0;
    }
  },
  data() {
    return {
      errors: [],
      cart: [],
      formData: {
        email: null,
        password: null
      },
      shippingTypes: [],
      selectedRate: null,
      submitted: false,
      order: {
        customer_id: localStorage.getItem("customer_id"),
        shipping_type: "REGULAR",
        shipping_rate_id: null,
        payment_type: "COD"
      },
      amount: 0,
      grandTotal: 0.0,
      discount: 0.0,
      deliveryCharge: 0.0,
      gift: false,
      giftPrice: 0,
      promoAmount: 0,
      couponDisabled: 0,
      promoCode: "",
      promo: null,
      placeHolder: "Enter your promo code",
      deliveryContents: {},
      customerInfo: {
        mobile: '',
        name: '',
        address: ''
      },
      mobileError: false,
      isValidMobile: false
    };
  },
  mounted() {
    /* 0 Always open the cart page at the top (so items are seen first),
       regardless of the scroll position on the page we navigated from. */
    this.$nextTick(() => window.scrollTo(0, 0));

    /* 1 Initialize gift */
    this.giftPrice = 0;

    /* 2 Load cart from API */
    this.loadCart();

    /* 3 Reset promo state */
    this.promo = null;
    this.promoCode = "";
    this.discount = 0;

    /* 4 Load delivery content */
    this.getDeliveryContents();

    /* 5 Load shipping types (delivery area options) */
    this.fetchShippingTypes();

    if (localStorage.getItem("token")) {
      this.couponDisabled = 0;
      this.placeHolder = "Enter your coupon";

      // Set default values from localStorage
      this.customerInfo.name = localStorage.getItem("name") || '';
      this.customerInfo.mobile = localStorage.getItem("mobile") || '';

      // Validate mobile number if it exists
      if(this.customerInfo.mobile) {
        this.validateMobile();
      }
    }
  },
  methods: {
    loadCart() {
      const sessionId = localStorage.getItem("session_id");
      this.$http.get("cart/" + sessionId).then(response => {
        if (response.data.status) {
          this.cart = response.data.cart;
          this.amount = response.data.total;
          localStorage.setItem("cartCount", response.data.count);
          localStorage.setItem("cartAmount", parseFloat(response.data.total || 0).toFixed(2));
          $(".cart-count").text(response.data.count);
          this.recalculateDiscount();
          this.applyShipping();
          this.calculateGrandTotal();
          window.dispatchEvent(new Event("cart-updated"));
        }
      });
    },
    fetchShippingTypes() {
      this.$http
        .get("get-shipping-types")
        .then(response => {
          if (response.data && response.data.status) {
            this.shippingTypes = response.data.shippingTypes || [];
            if (this.shippingTypes && this.shippingTypes.length > 0) {
              this.selectedRate = this.shippingTypes[0];
              this.order.shipping_rate_id = this.selectedRate.id;
              this.applyShipping();
            }
          } else {
            this.shippingTypes = [];
          }
        })
        .catch(() => {
          this.shippingTypes = [];
        });
    },
    selectShippingType(rate) {
      this.selectedRate = rate;
      this.order.shipping_rate_id = rate.id;
      this.applyShipping();
    },
    selectPaymentType(type) {
      this.order.payment_type = type;
    },
    freeShippingApplies(rate) {
      const t = parseFloat(rate && rate.free_shipping_threshold);
      return t > 0 && (parseFloat(this.amount) || 0) >= t;
    },
    applyShipping() {
      if (!this.selectedRate) return;
      // No delivery charge for an empty cart.
      if (this.cart.length === 0) {
        this.deliveryCharge = 0;
      } else {
        this.deliveryCharge = this.freeShippingApplies(this.selectedRate)
          ? 0
          : parseFloat(this.selectedRate.inside_price) || 0;
      }
      localStorage.setItem("deliveryCharge", this.deliveryCharge);
      this.calculateGrandTotal();
    },
    placeOrder() {
      if (this.cart.length < 1) {
        this.flashMessage.error({
          message: "আপনার শপিং কার্ট খালি!!!",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      // Store customer info in localStorage
      localStorage.setItem("customerInfo", JSON.stringify(this.customerInfo));

      // Check if all required customer info is filled
      if (!this.customerInfo.mobile || !this.customerInfo.name) {
        this.flashMessage.error({
          message: "দয়া করে আপনার নাম এবং ফোন নম্বর দিন",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      if (!this.isValidMobile) {
        this.flashMessage.error({
          message: "সঠিক মোবাইল নাম্বার দিন (১১ ডিজিট)",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      if (!this.customerInfo.address || this.customerInfo.address.trim() === '') {
        this.flashMessage.error({
          message: "দয়া করে আপনার ঠিকানা দিন",
          time: 3000,
          blockClass: 'error-message'
        });
        return false;
      }

      if (!this.order.shipping_rate_id) {
        this.flashMessage.error({ message: "ডেলিভারি এরিয়া সিলেক্ট করুন" });
        return false;
      }

      if (!this.order.payment_type) {
        this.flashMessage.error({ message: "পেমেন্ট টাইপ সিলেক্ট করুন" });
        return false;
      }

      if (window.fbq) {
        fbq('track', 'InitiateCheckout', {
          value: parseFloat(this.grandTotal) || 0,
          currency: 'BDT',
          num_items: this.cart.length
        });
      }

      this.submitted = true;

      // Assign cart to customer by mobile, then place the order.
      this.$http.post("cart/assign", {
        session_id: localStorage.getItem("session_id"),
        customer_mobile: this.customerInfo.mobile,
        customer_name: this.customerInfo.name
      }).then(() => {
        this.submitOrder();
      }).catch(() => {
        this.submitOrder();
      });
    },
    submitOrder() {
      this.order.session_id = localStorage.getItem("session_id");
      this.order.customer_id = localStorage.getItem("customer_id");
      this.order.shipping_cost = this.deliveryCharge;
      this.order.service_charge = this.giftPrice;
      this.order.discount_amount = this.discount;
      this.order.promo_code = localStorage.getItem("promoCode") || "";
      this.order.customer_mobile = this.customerInfo.mobile;
      this.order.customer_name = this.customerInfo.name;
      this.order.customer_address = this.customerInfo.address;

      this.$http
        .post("order", this.order)
        .then(response => {
          if (response.data.order_id && this.order.payment_type == 'COD') {
            // Clear cart-related localStorage
            localStorage.removeItem("cartCount");
            localStorage.removeItem("cartAmount");
            localStorage.removeItem("promoCode");
            localStorage.removeItem("discount");
            localStorage.removeItem("deliveryCharge");
            localStorage.removeItem("giftPrice");
            localStorage.removeItem("gift");
            // Pixel Purchase value — set only after backend confirmed order_id.
            localStorage.setItem("lastGrandTotal", this.grandTotal);
            location.href = "success?order_no=" + response.data.order_no + "&order_id=" + response.data.order_id;
          } else if (response.data.order_id && this.order.payment_type == 'SSL') {
            let redirect_to = process.env.VUE_APP_BASEURL;
            let orderId = response.data.order_id;
            // Pixel Purchase value — survives SSL gateway redirect via localStorage.
            localStorage.setItem("lastGrandTotal", this.grandTotal);
            location.href = process.env.VUE_APP_DOMAIN + 'pay-now/' + orderId + '?redirect_to=' + redirect_to;
          } else {
            this.submitted = false;
            this.flashMessage.error({ message: response.data.message || "একটি ত্রুটি ঘটেছে, পরে আবার চেষ্টা করুন" });
            return false;
          }
        })
        .catch(() => {
          this.submitted = false;
          this.flashMessage.error({ message: "একটি ত্রুটি ঘটেছে, পরে আবার চেষ্টা করুন" });
        });
    },
    clearPromo() {
      this.promo = null;
      this.promoCode = "";
      this.discount = 0;
    },
    recalculateDiscount() {
      const amount = Number(this.amount);

      if (!this.promo) {
        this.discount = 0;
        return;
      }

      // optional minimum cart check
      if (this.promo.min_order_amount && amount < this.promo.min_order_amount) {
        this.discount = 0;
        this.flashMessage.error({
          message: "এই প্রোমো কোডটি ব্যবহার করতে সর্বনিম্ন ৳" + this.promo.min_order_amount + " অর্ডার করতে হবে।"
        });
        return;
      }

      if (this.promo.amount_type === "fixed") {
        this.discount = this.promo.amount;
      } else {
        this.discount = Math.floor((amount * this.promo.amount) / 100);
      }

      localStorage.setItem("discount", this.discount);
    },
    validatePromo() {
      this.$http
        .get("promo/" + this.promoCode)
        .then(response => {
          if (response.data.status) {
            this.promo = response.data.promo;
            localStorage.setItem("promoCode", this.promoCode);
            this.recalculateDiscount();
          } else {
            this.clearPromo();
            localStorage.removeItem("promoCode");
            this.flashMessage.error({
              message: "আপনি ভুল কুপন কোড প্রবেশ করেছেন"
            });
          }

          this.calculateGrandTotal();
        })
    },
    checkForm: function(e) {
      e.preventDefault();

      if (!this.formData.email) {
        this.flashMessage.error({
          message: "আপনার মোবাইল নাম্বার/ইমেইল লিখুন"
        });
        return false;
      }

      if (!this.formData.password) {
        this.flashMessage.error({ message: "আপনার পাসওয়ার্ড লিখুন" });
        return false;
      }

      //console.log(this.formData);
    },
    removeFromCart(item) {
      if (confirm("Are you sure you want to delete?")) {
        this.$http.post("cart/remove", {
          cart_id: item.cart_id,
          session_id: localStorage.getItem("session_id")
        }).then(response => {
          if (response.data.status) {
            $(".cart-count").text(response.data.cart_count);
            localStorage.setItem("cartCount", response.data.cart_count);
            this.loadCart();
          }
        });
      }
    },
    decQty(item) {
      var currentQty = Number(item.quantity) - 1;
      if (currentQty < 1) {
        return false;
      }
      this.$http.post("cart/update-qty", {
        cart_id: item.cart_id,
        quantity: currentQty
      }).then(response => {
        if (response.data.status) {
          this.loadCart();
        }
      });
    },
    incQty(item) {
      var currentQty = Number(item.quantity) + 1;
      if (item.stock && currentQty > Number(item.stock)) {
        this.flashMessage.error({ message: "স্টকে পর্যাপ্ত পরিমাণ নেই" });
        return false;
      }
      this.$http.post("cart/update-qty", {
        cart_id: item.cart_id,
        quantity: currentQty
      }).then(response => {
        if (response.data.status) {
          this.loadCart();
        }
      });
    },
    giftToggle() {
      if (this.gift) this.gift = false;
      else this.gift = true;
      if (this.gift) this.giftPrice = 20;
      else this.giftPrice = 0;

      localStorage.setItem("giftPrice", this.giftPrice);
      localStorage.setItem("gift", true);
      //console.log(localStorage.getItem("gift"));

      this.recalculateDiscount();
      this.calculateGrandTotal();
    },
    calculateGrandTotal() {
      if (this.cart.length === 0) {
        this.grandTotal = (0).toFixed(2);
        return;
      }
      this.grandTotal = (Number(this.amount) + Number(this.deliveryCharge) + Number(this.giftPrice)) - Number(this.discount || 0);
      this.grandTotal = Math.ceil(this.grandTotal).toFixed(2);
    },
    getDeliveryContents() {
      fetch(this.APIURL + "cms-resources/Delivery-Contents")
        .then((response) => response.json())
        .then((json) => {
          this.deliveryContents = json.data[0];
          //console.log('json.data', json.data[0]);
        });
    },
    validateMobile() {
      // Remove any spaces and non-digit characters
      const mobileNumber = this.customerInfo.mobile.replace(/\D/g, '');
      
      // Check if it's a valid Bangladeshi number (11 digits starting with 01)
      const isValid = /^01\d{9}$/.test(mobileNumber);
      
      this.mobileError = mobileNumber.length > 0 && !isValid;
      this.isValidMobile = isValid;
      
      // Update the mobile number to show only digits
      this.customerInfo.mobile = mobileNumber;
    },
  }
};
</script>

<style scoped>
.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  border: 1px solid #f5c6cb;
}

/* Standard, uniform cart-row cover image */
.cart-image {
  height: 60px;
  width: 44px;
  object-fit: cover;
  border-radius: 4px;
}

/* Checkout action buttons: two equal halves (50/50), always side by side. */
.cart-actions .btn {
  flex: 1 1 0;
  min-width: 0;
  white-space: normal;
}

/* Order items card (right sidebar) */
.order-items-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  /* Match the 10px top margin the global "#cart-page section" rule gives the
     left-column sections, so both columns' first cards align at the top. */
  margin-top: 10px;
}
.order-items-card__header {
  font-weight: 700;
  font-size: 18px;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  background: #fff;
  color: #333;
}
.order-items-card .cart-items {
  padding: 4px 12px;
}

/* Unify every section title to match the order-items header:
   bigger font + full-width bottom border (negative side margins pull the bar
   out past each section's p-3 padding). !important beats the global
   "#cart-page .fixed-checkout .check-sidebar .checkout-sidebar__header" rule
   that otherwise forces padding-bottom:0 (summary title overlapped its border). */
.shipping-address .checkout-sidebar__header,
#checkout-sidebar .checkout-sidebar__header,
.delivery-section > h4,
.payment-section > h4 {
  margin: 0 -1rem 16px !important;
  padding: 0 16px 12px !important;
  border-bottom: 1px solid #eee !important;
}
.shipping-address .checkout-sidebar__header h1,
#checkout-sidebar .checkout-sidebar__header h1,
.delivery-section > h4,
.payment-section > h4 {
  font-size: 18px !important;
  font-weight: 700;
  line-height: 1.3;
  color: #333;
}
.shipping-address .checkout-sidebar__header h1,
#checkout-sidebar .checkout-sidebar__header h1 {
  margin: 0;
}

/* Compact cart row */
.cart-item + .cart-item {
  border-top: 1px solid #eee;
}
.cart-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 10px 0;
}
.cart-row__thumb {
  flex: 0 0 auto;
  display: block;
}
.cart-row__body {
  flex: 1 1 auto;
  min-width: 0;
}
.cart-row__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 6px;
}
.cart-row__name {
  font-weight: 600;
  color: var(--red, #aa4242);
  line-height: 1.4;
}
.cart-row__remove {
  flex: 0 0 auto;
  color: #c0392b;
  font-size: 16px;
  line-height: 1;
  padding: 2px 6px;
}
.cart-row__remove:hover {
  color: #8a1f14;
}
.cart-row__calc {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.cart-row__math {
  font-size: 14px;
  color: #777;
}
.cart-row__math .line-total {
  color: #222;
  font-size: 15px;
}
.cart-row__math .eq {
  margin: 0 2px;
}
/* No hover highlight on cart rows */
.cart-item:hover {
  background-color: transparent !important;
}

.qty-stepper {
  display: inline-flex;
  align-items: center;
  gap: 0;
}
.qty-stepper .btn {
  height: 30px;
  padding: 0 9px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.qty-stepper .product-qty {
  width: 40px;
  height: 30px;
  padding: 2px;
  text-align: center;
  display: inline-block;
}
/* Join the −, qty, + into one segmented control: only the outer corners round,
   inner edges square, and overlap borders by -1px for a single clean seam. */
.qty-stepper .js-minus-btn {
  border-radius: 4px 0 0 4px;
}
.qty-stepper .product-qty {
  border-radius: 0;
  margin-left: -1px;
}
.qty-stepper .js-plus-btn {
  border-radius: 0 4px 4px 0;
  margin-left: -1px;
}

/* Sticky order-summary card on desktop so the place-order button stays reachable */
@media (min-width: 992px) {
  .fixed-checkout {
    position: sticky;
    top: 20px;
  }
}

/* Keep long carts (10-15 items) tidy: scroll the list, keep summary in view */
.cart-items {
  max-height: 60vh;
  overflow-y: auto;
}

@media (max-width: 767px) {
  .cart-image {
    height: 56px;
    width: 42px;
  }
  .cart-items {
    max-height: none;
  }
  /* Cart page only (scoped): the global ".contents { padding: 40px 0 }" zeroes the
     container's side padding, so the white cards touch the screen edges on mobile.
     Restore 15px sides here — 15px contains the row's -15px gutter (no overflow). */
  .container.contents {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  /* Payment / delivery options: shrink icons + tighten padding so the label
     isn't squeezed (was wrapping to 2 lines with an oversized icon). */
  .payment-option,
  .delivery-option {
    padding: 12px;
  }
  .payment-icon {
    margin-left: 10px;
  }
  .payment-icon img {
    height: 32px !important;
    width: auto;
    max-width: 84px;
    object-fit: contain;
  }
  .payment-option h5,
  .delivery-option h5 {
    font-size: 14px;
    margin-bottom: 2px;
  }
}
</style>

